import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SupportService, SupportTicket } from '../support.service';

@Component({
    selector: 'app-support-ticket-list',
    templateUrl: './support-ticket-list.component.html',
    styleUrls: ['./support-ticket-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SupportTicketListComponent implements OnInit {
    @Output() selectTicket = new EventEmitter<string>();
    @Output() newTicket = new EventEmitter<void>();

    tickets: SupportTicket[] = [];
    loading = true;
    error: string | null = null;

    constructor(
        private supportService: SupportService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.loadTickets();
    }

    loadTickets(): void {
        this.loading = true;
        this.error = null;
        this.supportService.listTickets().subscribe({
            next: data => {
                this.tickets = data.values ?? [];
                this.loading = false;
                this.cdr.markForCheck();
            },
            error: err => {
                this.error = 'Unable to load tickets. Please try again.';
                this.loading = false;
                this.cdr.markForCheck();
            },
        });
    }

    getStatusClass(status: string): string {
        const s = (status || '').toLowerCase();
        if (s.includes('resolved') || s.includes('closed') || s.includes('done')) return 'status-resolved';
        if (s.includes('progress') || s.includes('open') || s.includes('waiting')) return 'status-open';
        return 'status-default';
    }
}
